const inter = 'Inter'
const barlow = 'Barlow'
const barlowComponent = 'Barlow !important'
const interComponent = 'Inter !important'
/** Chips de timestamp e leituras técnicas — espelha `--font-mono` do mockup. */
const mono =
  'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
const monoComponent = `${mono} !important`

const fonts = {
  inter,
  barlow,
  interComponent,
  barlowComponent,
  mono,
  monoComponent,
}

export default fonts
